/**Payment saga */
import { call, put, takeLatest } from 'redux-saga/effects';
import { httpRequestsOnLoadActions } from '../http_requests_on_load';
import { httpRequestsOnSuccessActions } from '../http_requests_on_success';
import { httpRequestsOnErrorsActions } from '../http_requests_on_errors';
import {
    ASSIGN_CARD,
    GET_CURRENT_CARD,
    GET_CURRENT_CARD_SUCCESS,
    GET_PAYMENT_INVOICES,
    GET_PAYMENT_INVOICES_SUCCESS,
    UN_ASSIGN_CARD,
    UN_ASSIGN_CARD_SUCCESS,
} from './payments.types';
import { paymentService } from './payments.service';

function* assignCard({ type, payload }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(paymentService.assignCardService, payload?.params);
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put({
            type: GET_CURRENT_CARD,
        });
        yield put(httpRequestsOnErrorsActions.removeError(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    } catch (err) {
        yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}
function* unAssignCard({ type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(paymentService.unAssignCardService);
        yield put({
            type: UN_ASSIGN_CARD_SUCCESS,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
    } finally {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}

function* getCurrentCard({ type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        const res = yield call(paymentService.getCurrentCardService);
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put({
            type: GET_CURRENT_CARD_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnErrorsActions.removeError(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    } catch (err) {
        yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}

function* getInvoices({ type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        const res = yield call(paymentService.getInvoicesService);
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put({
            type: GET_PAYMENT_INVOICES_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnErrorsActions.removeError(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    } catch (err) {
        yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}

export const watchPayments = function* () {
    yield takeLatest(ASSIGN_CARD, assignCard);
    yield takeLatest(UN_ASSIGN_CARD, unAssignCard);
    yield takeLatest(GET_CURRENT_CARD, getCurrentCard);
    yield takeLatest(GET_PAYMENT_INVOICES, getInvoices);
};
